import React, { PureComponent } from 'react';
import { format } from 'd3';
import './BreakdownTable.css'

const MAX_NUM_NESTED_CHILDREN = 10 // number of nested children to display in an expanded row

const weightFormat = format('.2%')

class BreakdownTable extends PureComponent {
  render() {
    const { data, nestedChildren, onHighlight, onExpand, highlighted, expanded, colorScale,
            nameColumnLabel, weightColumnLabel, sectorHoldingsLabel, sectorHoldingsTopLabel, sectorHoldingsWeightLabel,
            weightField, nameField, childWeightField, childNameField, } = this.props
    return (
      <div className='BreakdownTable dc-col-sm-6'>
        <div className='BreakdownTable-header BreakdownTable-row'>
          <div className='BreakdownTable-row-inner'>
            <div className='BreakdownTable-name'>{nameColumnLabel}</div>
            <div className='BreakdownTable-weight'>{weightColumnLabel}</div>
          </div>
        </div>
        <div
          onMouseLeave={() => onHighlight(null)}
        >{
          data.map((d,i) => (
            <div
              key={i}
              className={[
                'BreakdownTable-row',
                onExpand ? 'expandable' : '',
                d[nameField] === highlighted ? 'highlighted' : '',
                d[nameField] === expanded    ? 'expanded' : '',
              ].join(' ')}
              onClick={onExpand ? () => onExpand(d[nameField]) : null /* TEMP: disable clicks / graphs: onSelect(d[nameField]) */}
              onMouseEnter={() => onHighlight(d[nameField])}
            >
              <div className='BreakdownTable-row-inner'>
                { nestedChildren ? 
                  <div
                    className='BreakdownTable-expand-collapse'
                    onClick={() => onExpand(d[nameField]) }
                  /> : null 
                }
                <div className='BreakdownTable-name'>
                  <div
                    className='BreakdownTable-bullet'
                    style={{ background: colorScale(d[nameField]) }}
                  />
                  {d[nameField]}
                </div>
                <div className='BreakdownTable-weight'>{weightFormat(d[weightField])}</div>
              </div>
              {
                nestedChildren && d[nameField] === expanded ? <div>
                  <div className='BreakdownTable-child-header BreakdownTable-child-row'>
                    <div className='BreakdownTable-row-inner'>
                      <div className='BreakdownTable-name'>{
                        nestedChildren(d).length < MAX_NUM_NESTED_CHILDREN
                        ? `${sectorHoldingsLabel} (${nestedChildren(d).length})`
                        : `${sectorHoldingsTopLabel} (${MAX_NUM_NESTED_CHILDREN})`
                      }</div>
                      <div className='BreakdownTable-weight'>{sectorHoldingsWeightLabel}</div>
                    </div>
                  </div>
                  {
                    nestedChildren(d)
                      .slice(0, MAX_NUM_NESTED_CHILDREN)
                      .map((c, i) => (
                        <div key={i} className='BreakdownTable-child-row'>
                          <div className='BreakdownTable-row-inner'>
                            <div className='BreakdownTable-name'>{c[childNameField]}</div>
                            <div className='BreakdownTable-weight'>{weightFormat(c[childWeightField])}</div>
                          </div>
                        </div>
                      ))
                  }
                </div> : null
              }
            </div>
          ))
        }</div>
      </div>
    )
  }
}

BreakdownTable.defaultProps = {
  nameColumnLabel: 'Name',
  weightColumnLabel: 'Weight (%)',
  sectorHoldingsLabel: 'Sector holdings',
  sectorHoldingsTopLabel: 'Top holdings in sector',
  sectorHoldingsWeightLabel: 'Weight of holding (%)',
}

export default BreakdownTable


// WEBPACK FOOTER //
// ./src/BreakdownTable.js